import React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import strings from "../../localization/strings"
import TableActionBar from "../../components/layout/TableActionBar"
import autobind from "class-autobind"
import { IHolidayTemplate } from "../../models"
import AddHolidayTemplate from "./AddHolidayTemplate"
import moment from 'moment'
import * as timeHelper from "../../helpers/timeHelper"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"
interface IProps {
  holidayTemplates: IHolidayTemplate[]
  addHolidayTemplate(holidayTempalte: IHolidayTemplate, cb?: () => void): void
  updateHolidayTemplate(holidayTempalte: IHolidayTemplate, cb?: () => void): void
  deleteHolidayTemplate(holidayTempalteId: string, cb?: (deleteResult: boolean) => void): void
}
interface IState {
  searchedHolidayTemplates: IHolidayTemplate[]
  selectedHolidayTemplate: IHolidayTemplate
  openAddHolidayTemplate: boolean
  editHolidayTemplate: IHolidayTemplate
  searchText: string
}

export default class HolidayTemplates extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      searchedHolidayTemplates: [],
      selectedHolidayTemplate: null,
      openAddHolidayTemplate: false,
      editHolidayTemplate: null,
      searchText: "",
    }
    autobind(this)
  }

  componentDidMount() {
    this.setState({
      searchedHolidayTemplates: this.props.holidayTemplates,
      selectedHolidayTemplate: null,
    })
  }

  componentWillReceiveProps(nextProps) {
    !_.isEqual(this.props.holidayTemplates, nextProps.holidayTemplates) &&
      this.setState({
        searchedHolidayTemplates: nextProps.holidayTemplates,
        selectedHolidayTemplate: null,
        searchText: ""
      })
  }

  handleSelectHolidayTemplate(rowNumber, colId) {
    colId === -1 ?
      this.setState({ selectedHolidayTemplate: this.state.selectedHolidayTemplate && this.state.selectedHolidayTemplate.Id === this.state.searchedHolidayTemplates[rowNumber].Id ? null : this.state.searchedHolidayTemplates[rowNumber] }) :
      this.setState({ openAddHolidayTemplate: true, editHolidayTemplate: this.state.searchedHolidayTemplates[rowNumber] })
  }

  addHolidayTemplate(holidayTemplate: IHolidayTemplate) {
    AppStateStore.setProgressSnackbarContent("loading")
    this.setState({ openAddHolidayTemplate: false }, () =>
      this.props.addHolidayTemplate(holidayTemplate, () => {
        AppStateStore.setProgressSnackbarContent(strings.Holiday_Template_created_successfully)
        this.setState({
          searchText: "",
          selectedHolidayTemplate: null
        })
      })
    )
  }

  updateHolidayTemplate(holidayTemplate: IHolidayTemplate) {
    AppStateStore.setProgressSnackbarContent("loading")
    this.setState({ openAddHolidayTemplate: false }, () =>
      this.props.updateHolidayTemplate(holidayTemplate, () => {
        AppStateStore.setProgressSnackbarContent(strings.Holiday_Template_updated_successfully)
        this.setState({
          selectedHolidayTemplate: null,
          searchText: ""
        })
      })
    )
  }

  handleDeleteDialog() {
    AccountStore.getCurrentAccount().PayGroups.find(item =>
      item.Holidays && item.Holidays.find(holiday => holiday.HolidayTemplateId === this.state.selectedHolidayTemplate.Id) ? true : false
    ) ?
      AppStateStore.setAlertDialogContent({
        content: strings.Cannot_delete_holiday_template
      }) :
      AppStateStore.setConfirmDialogContent({
        title: strings.Delete_Holiday_Template,
        content: strings.Are_you_sure_delete_holiday_template,
        confirm: () => this.props.deleteHolidayTemplate(this.state.selectedHolidayTemplate.Id, () => {
          AppStateStore.setProgressSnackbarContent(strings.Holiday_Template_removed_successfully)
          this.setState({ selectedHolidayTemplate: null, searchText: "" })
        })
      })
  }

  handleSearch(searchText) {
    const searchedHolidayTemplates = this.props.holidayTemplates.slice().filter((holidayTempalte) => {
      return holidayTempalte.Name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
    })
    this.setState({ searchText, selectedHolidayTemplate: null, searchedHolidayTemplates })
  }

  render() {
    return (
      <div>
        <FloatingActionButton
          data-intercom-target={"menu-AccountSettings-PayConfiguration-HolidayTemplatesTab-Btn-Add"}
          className="fixed-add"
          style={{ top: -28, right: 20 }}
          secondary={true}
          onTouchTap={() => this.setState({ openAddHolidayTemplate: true, editHolidayTemplate: null })}
        >
          <ContentAdd />
        </FloatingActionButton>
        <div style={{ paddingTop: 30 }}>
          <TableActionBar
            searchText={this.state.searchText}
            onSearch={this.handleSearch}
            rowSelectionCount={this.state.selectedHolidayTemplate ? 1 : 0}
            singleSelectedMessage={strings.Holiday_Template_Selected}
            title={strings.Holiday_Templates}
            titleStyle={{ fontSize: 16 }}
            bodyStyle={{ padding: 20, fontWeight: 500 }}
            onDeleteClick={this.handleDeleteDialog}
          />
          <div style={{ maxHeight: 250, overflowY: "auto" }}>
            {this.state.searchedHolidayTemplates.length === 0 ?
              <h2 style={{ textAlign: "center", fontSize: 25, paddingTop: 50, fontWeight: "bold" }}>{strings.No_Holiday_Template}</h2> :
              <Table onCellClick={this.handleSelectHolidayTemplate}>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn style={{ textAlign: "left", width: 100 }}>{strings.Name}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "center", width: 75 }}>{strings.Hours_Per_Day}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Dates}</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody deselectOnClickaway={false}>
                  {this.state.searchedHolidayTemplates.map((holidayTempalte, index) => {
                    let datesString = ""
                    holidayTempalte.Dates.forEach(date => {
                      datesString += `${moment(timeHelper.keepConvertUTCToLocal(date)).format("DD/MM/YYYY")},  `
                    })
                    return (
                      <TableRow data-intercom-target={index === 0 && "menu-AccountSettings-PayConfiguration-HolidayTemplatesTab-openItemDetails"} selected={this.state.selectedHolidayTemplate && this.state.selectedHolidayTemplate.Id === holidayTempalte.Id} key={index}>
                        <TableRowColumn style={{ cursor: "pointer", textAlign: "left", width: 100 }}>{holidayTempalte.Name}</TableRowColumn>
                        <TableRowColumn style={{ cursor: "pointer", textAlign: "center", width: 75 }}>{holidayTempalte.HoursPerDay}</TableRowColumn>
                        <TableRowColumn style={{ cursor: "pointer", textAlign: "left" }}>{datesString}</TableRowColumn>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            }
          </div>
        </div>
        {this.state.openAddHolidayTemplate &&
          <AddHolidayTemplate
            existingHolidayTemplates={this.props.holidayTemplates}
            editHolidayTemplate={this.state.editHolidayTemplate}
            handleClose={() => this.setState({ openAddHolidayTemplate: false, editHolidayTemplate: null })}
            handleAdd={this.addHolidayTemplate}
            handleUpdate={this.updateHolidayTemplate}
          />
        }
      </div>
    )
  }
}
